module.exports = __webpack_public_path__ + "fonts/montserrat-v12-latin-800.75665590.woff";